import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect } from 'react';

import type { TFullData } from 'shared/types/TUserAddressFields';

import type { TPassportFormFields } from 'entities/creditForm';

export const useUpdateResidenceFields = () => {
  const { watch, setValue } = useFormContext<TPassportFormFields>();
  const isSameAddresses = watch('residenceAddressIsRegistration');
  const registrationAddress = watch('registrationAddress');
  const registrationAddressDadata = watch('registrationAddress.data');
  const registrationAddressFlat = watch('registrationAddressFlat');

  const updateResidenceAddressFlat = useCallback(
    (newRegFlat: TPassportFormFields['registrationAddressFlat']) => {
      if (!newRegFlat) {
        setValue('residenceAddressFlat', '', { shouldValidate: false });
        return;
      }
      setValue('residenceAddressFlat', newRegFlat, { shouldValidate: true });
    },
    [setValue],
  );

  const updateResidenceAddress = useCallback(
    (newRegAddress: TPassportFormFields['registrationAddress']) => {
      if (!newRegAddress?.data) {
        setValue('residenceAddress', null, { shouldValidate: false });
        return;
      }
      const data = newRegAddress.data as TFullData | { type: 'manual' };
      if ('type' in data && data.type === 'manual') {
        setValue('residenceAddress', null, { shouldValidate: false });
      } else {
        setValue(
          'residenceAddress',
          {
            data: {
              ...newRegAddress.data,
            },
            value: newRegAddress.value,
            label: newRegAddress.label,
          } as TPassportFormFields['residenceAddress'],
          { shouldValidate: true },
        );
      }
    },
    [setValue],
  );

  useEffect(() => {
    if (isSameAddresses) {
      updateResidenceAddress(registrationAddress);
    }
    //   eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSameAddresses, registrationAddressDadata]);

  useEffect(() => {
    if (isSameAddresses) {
      updateResidenceAddressFlat(registrationAddressFlat);
    }
    //   eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registrationAddressFlat, isSameAddresses]);
};
